import { render, staticRenderFns } from "./ed-create-other-files-object.vue?vue&type=template&id=3b0526f6&"
import script from "./ed-create-other-files-object.ts?vue&type=script&lang=ts&"
export * from "./ed-create-other-files-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-other-files-object.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports